// extracted by mini-css-extract-plugin
export var active = "_7i-a";
export var activeIndicator = "_7i-8";
export var animate = "_7i-9";
export var disabled = "_7i-b";
export var fullWidth = "_7i-2";
export var lg = "_7i-7";
export var md = "_7i-6";
export var redoButtonTabGroup = "_7i-0";
export var sm = "_7i-5";
export var tabButton = "_7i-3";
export var tabButtonsContainer = "_7i-1";
export var xs = "_7i-4";